import { Images } from "@assets/images";

function ProductWarrantyPolicy() {
  return (
    <div className="bg-gray-100 min-h-screen flex justify-center py-8">
      <div className="px-10 py-8 bg-white shadow-md rounded-lg max-w-screen-lg mx-auto">
        <div className="flex justify-center mb-8">
          <img className="w-2/3 md:w-1/3" src={Images.LogoText.default} alt="Logo" />
        </div>
        <h1 className="text-3xl font-bold mb-4 text-gray-800 text-center">Chính sách bảo hành sản phẩm</h1>
        <p className=" text-gray-600">
          Chúng tôi cam kết thường xuyên kiểm tra và bảo trì hệ thống để việc sử dụng website của quý khách được thuận lợi, không bị gián đoạn. 
          Nếu có phát sinh sự cố kỹ thuật, chúng tôi sẽ khắc phục trong thời gian sớm nhất.
        </p>
      </div>
    </div>
  );
}

export default ProductWarrantyPolicy;
